(() => {
  const markerSelector = '.velomint-unavailable-product-marker[data-velomint-unavailable="true"]';
  let directProductChecked = false;
  let sortScheduled = false;

  function clean(root = document) {
    root.querySelectorAll(markerSelector).forEach((marker) => {
      const wrapper = marker.closest(
        'li.grid__item, li.slider__slide, .grid__item, .slider__slide, .collage__item, .product-grid > li, .predictive-search__list-item'
      );
      if (wrapper) {
        wrapper.remove();
      } else {
        marker.remove();
      }
    });

    document.querySelectorAll('product-recommendations.related-products').forEach((section) => {
      const grid = section.querySelector('.product-grid');
      if (grid && !grid.querySelector('.card-wrapper, product-component')) {
        section.style.display = 'none';
      }
    });
  }

  function isAuthorizationCard(item) {
    if (!(item instanceof Element)) return false;
    if (item.querySelector('.velomint-card-consult')) return true;
    const text = item.textContent || '';
    return text.includes('Disponibilidad bajo consulta') || text.includes('Pedir autorización');
  }

  function deliveryRank(item) {
    if (!(item instanceof Element)) return 99;

    if (item.querySelector('.velomint-card-delivery--unavailable')) return 3;
    if (isAuthorizationCard(item)) return 2;
    if (item.querySelector('.velomint-card-delivery--immediate')) return 0;

    const text = item.textContent || '';
    if (text.includes('Envío inmediato')) return 0;
    if (text.includes('Entrega estimada 4–7 días')) return 1;

    return 1;
  }

  function reorderByDelivery(root = document) {
    const grids = [];
    if (root instanceof Element && root.matches('.product-grid')) grids.push(root);
    root.querySelectorAll?.('.product-grid').forEach((grid) => grids.push(grid));

    grids.forEach((grid) => {
      const items = Array.from(grid.children).filter((item) => item instanceof Element);
      if (items.length < 2) return;

      const ranked = items.map((item, index) => ({ item, index, rank: deliveryRank(item) }));
      const sorted = [...ranked].sort((a, b) => a.rank - b.rank || a.index - b.index);
      const changed = sorted.some((entry, index) => entry.item !== items[index]);
      if (!changed) return;

      sorted.forEach(({ item }) => grid.appendChild(item));
    });
  }

  function scheduleSort(root = document) {
    if (sortScheduled) return;
    sortScheduled = true;
    requestAnimationFrame(() => {
      sortScheduled = false;
      reorderByDelivery(root);
    });
  }

  async function hideDirectUnavailableProduct() {
    if (directProductChecked) return;
    directProductChecked = true;

    if (window.Shopify?.designMode) return;
    if (!window.location.pathname.startsWith('/products/')) return;

    const productInfo = document.querySelector('product-info[data-url]');
    if (!productInfo) return;

    // Solo las bicicletas que siguen realmente disponibles y requieren consulta
    // conservan el acceso directo. Los agotados reales se redirigen.
    if (productInfo.dataset.velomintAuthorization === 'required') return;

    try {
      const productPath = new URL(productInfo.dataset.url, window.location.origin).pathname.replace(/\/$/, '');
      const response = await fetch(`${productPath}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;

      const data = await response.json();
      if (!Array.isArray(data.variants)) return;

      const hasAvailableVariant = data.variants.some((variant) => variant.available === true);
      if (!hasAvailableVariant) {
        window.location.replace('/collections/all');
      }
    } catch {
      // Si la comprobación falla, no bloqueamos la navegación del cliente.
    }
  }

  function run(root = document) {
    clean(root);
    reorderByDelivery(root);
    hideDirectUnavailableProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(document));
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    clean(event.target);
    reorderByDelivery(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    let shouldSort = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.(markerSelector) || node.querySelector?.(markerSelector)) {
          clean(node.matches?.(markerSelector) ? node.parentElement || document : node);
        }
        if (
          node.matches?.('.product-grid, .product-grid > li, product-component') ||
          node.querySelector?.('.product-grid, product-component')
        ) {
          shouldSort = true;
        }
      }
    }
    if (shouldSort) scheduleSort(document);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
